<style>
  .cont {
    display: flex;
  }

  .cont > * {
    margin: 0 1em;
  }
</style>

<div class="list-page">
  <app-asiakas-otsikko [otsikko]="otsikkoObservable | async" [naytaPalaa]="true" [paluuUrl]="'/asiakkaat/' + $safeNavigationMigration(asiakas?.avain) + '/kayttajat'" [asiakas]="asiakas"></app-asiakas-otsikko>

  @if (kayttaja?.avain && kirjanpitajaOnDevaajaObservable | async) {
    <div style="margin-bottom: 20px; margin-left: 20px; padding: 10px; max-width: 1020px; position: relative" class="mat-elevation-z2">
      <span style="font-size: 10px; position: absolute; top: 3px; right: 5px" class="light-gray-text">(Vain devaajat)</span>
      <h3 style="margin: 0 0 1em">Urit</h3>
      <div style="padding-left: 1em; padding-right: 1em">
        <div>
          Käyttäjä (Lemonator): <a [href]="kayttajaEncodedUriObservable | async" target="_BLANK">{{ kayttajaUriObservable | async }}</a>
        </div>
        <div>
          Sopimusten hyväksynnät (Lemonaid): <a [href]="sopimustenHyvaksynnatEncodedUriObservable | async" target="_BLANK">{{ sopimustenHyvaksynnatUriObservable | async }}</a>
        </div>
        <div>
          Lähetetyt viestit (Lemonaid): <a [href]="lahetetytViestitEncodedUriObservable | async" target="_BLANK">{{ lahetetytViestitUriObservable | async }}</a>
        </div>
        @if (moniyritystukiNakymaObservable | async; as moniyritys) {
          <div>
            Moniyritystuen replika (Lemonator): <a [href]="moniyritystukiEncodedUriObservable | async" target="_BLANK">{{ moniyritys.replikaUri }}</a>
          </div>
        }
      </div>
    </div>
  }

  <div style="margin-bottom: 10px; margin-left: 0; margin-right: 0; font-size: 20px; line-height: 40px">
    @if (kayttaja?.avain && isAdmin()) {
      <app-button (click)="showKayttajaHistory()" actionId="Näytä käyttäjän muutoshistoria" [actionContext]="[kayttaja.avain]" styles="float: right;"> Näytä muutoshistoria </app-button>
    }
    @if (kayttaja?.avain) {
      <app-button (click)="vaihdaSalasana()" actionId="Avasi dialogin salasanan vaihtamista varten, käyttäjä" [actionContext]="[kayttaja.avain]" styles="float: right;">
        <!-- <mat-icon>lock</mat-icon><mat-icon>sync</mat-icon> -->
        Vaihda salasana
      </app-button>
    }
    @if (kayttaja?.avain && asiakas?.avain) {
      <app-button (click)="kirjauduKayttajana()" [actionId]="'Kirjaudu asiakkaan: ' + asiakas.avain + ' käyttäjänä: ' + kayttaja.avain" styles="float: right;">
        <!-- <mat-icon>lock</mat-icon><mat-icon>sync</mat-icon> -->
        Kirjaudu käyttäjänä
      </app-button>
    }
    @if (kayttaja?.avain && kirjanpitajaOnLuottoObservable | async) {
      <app-button (click)="pakotaVahvaTunnistautuminenUudelleen()" actionId="Avasi dialogin: Pakota pankkitunnistautuminen uudelleen" styles="float: right;">
        <!-- <mat-icon>lock</mat-icon><mat-icon>sync</mat-icon> -->
        Pakota pankkitunnistautuminen uudelleen
      </app-button>
    }
  </div>

  <br style="clear: both" />

  <mat-tab-group>
    <mat-tab label="Käyttäjän tiedot">
      <div style="padding: 20px">
        <form (ngSubmit)="save()" novalidate>
          <div style="max-width: 400px; margin-left: 20px">
            <mat-form-field>
              <mat-label>Etunimi</mat-label>
              <input #etunimiInput type="text" [formField]="lomake.etunimi" matInput />
              @if (naytaVirhe(lomake.etunimi, 'required')) {
                <mat-error> Etunimi puuttuu </mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>Sukunimi</mat-label>
              <input type="text" [formField]="lomake.sukunimi" matInput />
              @if (naytaVirhe(lomake.sukunimi, 'required')) {
                <mat-error> Sukunimi puuttuu </mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>Sähköpostiosoite</mat-label>
              <input type="text" [formField]="lomake.email" matInput />
              @if (naytaVirhe(lomake.email, 'required')) {
                <mat-error> Sähköpostiosoite puuttuu </mat-error>
              }
              @if (naytaVirhe(lomake.email, 'email')) {
                <mat-error> Sähköpostiosoite on virheellinen </mat-error>
              }
              @if (naytaVirhe(lomake.email, 'emailinuse')) {
                <mat-error> Sähköpostiosoite on jo käytössä </mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>Puhelinnumero</mat-label>
              <input type="text" [formField]="lomake.puhelin" matInput />
              @if (naytaVirhe(lomake.puhelin, 'minlength')) {
                <mat-error>
                  {{ 'lisaa-puhelin.min' | translate | async }}
                </mat-error>
              }
              @if (naytaVirhe(lomake.puhelin, 'invalid')) {
                <mat-error> Numero on virheellinen </mat-error>
              }
              @if (naytaVirhe(lomake.puhelin, 'notinternational')) {
                <mat-error> Numero ei ole kansainvälisessä muodossa ja ala plus-merkillä, esim. +358 </mat-error>
              }
              @if (naytaVirhe(lomake.puhelin, 'leadingzero')) {
                <mat-error>
                  {{ 'lisaa-puhelin.leadingzero' | translate | async }}
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>Asiointikieli</mat-label>
              <mat-select [formField]="lomake.asiointikieli">
                <mat-option [value]="'fi'">Suomi</mat-option>
                <mat-option [value]="'en'">Englanti</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-checkbox [formField]="lomake.aktiivinen">Aktiivinen</mat-checkbox>
          </div>

          <div id="roolit" [class.mat-form-field-invalid]="naytaVirhe(lomake.selvitettavienNakyvyys, 'required')" style="padding-top: 30px; margin-bottom: 10px; margin-left: 0; margin-right: 0; border-bottom: 1px solid lightgray; font-size: 20px; line-height: 40px">Selvitettävien tositteiden näkyvyys</div>

          <div style="margin-left: 20px">
            @if (naytaVirhe(lomake.selvitettavienNakyvyys, 'required')) {
              <mat-error> Valinta puuttuu </mat-error>
            }
            <mat-radio-group [formField]="lomake.selvitettavienNakyvyys">
              @for (e of selvitettavienNakyvyyksienArvot; track e) {
                <mat-radio-button [value]="e.arvo">{{ e.nimi }}</mat-radio-button
                ><br />
              }
            </mat-radio-group>
          </div>

          <div id="roolit" style="padding-top: 30px; margin-bottom: 10px; margin-left: 0; margin-right: 0; border-bottom: 1px solid lightgray; font-size: 20px; line-height: 40px">Käyttäjän roolit</div>

          <table style="margin-left: 20px">
            <tr>
              <td>
                <div style="padding-top: 10px; margin-bottom: 10px; margin-left: 0; margin-right: 0; font-size: 16px; line-height: 16px">Lemonaid</div>
                <table>
                  <tr>
                    <td style="vertical-align: top; padding: 0 20px">
                      <mat-checkbox [formField]="lomake.LASKUTUS">{{ rooliMap.get(Roolit.LASKUTUS) }}</mat-checkbox>
                    </td>
                    <td style="vertical-align: top; padding: 0 20px">
                      <mat-checkbox [formField]="lomake.TOSITTEET">Tositteet</mat-checkbox>
                      <div style="padding-left: 20px; padding-top: 10px">
                        <mat-checkbox [formField]="lomake.TOSITTEET_OSTO">{{ rooliMap.get(Roolit.TOSITTEET_OSTO) }}</mat-checkbox>
                      </div>
                      <div style="padding-left: 20px; padding-top: 5px">
                        <mat-checkbox [formField]="lomake.TOSITTEET_MYYNTI">{{ rooliMap.get(Roolit.TOSITTEET_MYYNTI) }}</mat-checkbox>
                      </div>
                      <div style="padding-left: 20px; padding-top: 5px">
                        <mat-checkbox [formField]="lomake.TOSITTEET_TILI">{{ rooliMap.get(Roolit.TOSITTEET_TILI) }}</mat-checkbox>
                      </div>
                      <div style="padding-left: 20px; padding-top: 5px">
                        <mat-checkbox [formField]="lomake.TOSITTEET_PALKKA">{{ rooliMap.get(Roolit.TOSITTEET_PALKKA) }}</mat-checkbox>
                      </div>
                      @if (kirjanpitajaOnLuottoObservable | async) {
                        <div style="padding-left: 20px; padding-top: 5px">
                          <mat-checkbox [formField]="lomake.SAHKOISTEN_LASKUJEN_VASTAANOTTO">{{ rooliMap.get(Roolit.SAHKOISTEN_LASKUJEN_VASTAANOTTO) }}</mat-checkbox>
                        </div>
                      }
                    </td>
                    <td style="vertical-align: top; padding: 0 20px">
                      <mat-checkbox [formField]="lomake.PALKAT">{{ rooliMap.get(Roolit.PALKAT) }}</mat-checkbox>
                    </td>
                    <td style="vertical-align: top; padding: 0 20px">
                      <mat-checkbox [formField]="lomake.MAKSUT">{{ rooliMap.get(Roolit.MAKSUT) }}</mat-checkbox>
                      <div style="padding-left: 10px; padding-top: 10px">Vastaanotto</div>
                      <div style="padding-left: 30px; padding-top: 10px">
                        <mat-checkbox [formField]="lomake.MAKSUT_VASTAANOTTAJA">{{ rooliMap.get(Roolit.MAKSUT_VASTAANOTTAJA) }}</mat-checkbox>
                      </div>
                      <div style="padding-left: 10px; padding-top: 10px">Maksaminen</div>
                      <div style="padding-left: 30px; padding-top: 5px">
                        <mat-checkbox [formField]="lomake.MAKSUT_HYVAKSYJA">{{ rooliMap.get(Roolit.MAKSUT_HYVAKSYJA) }}</mat-checkbox>
                      </div>
                      <div style="padding-left: 30px; padding-top: 10px">
                        @if ((kirjanpitajaOnLuottoObservable | async) || (kirjanpitajaOnDevaajaObservable | async)) {
                          <mat-checkbox [formField]="lomake.MAKSUT_MAKSAJA">{{ rooliMap.get(Roolit.MAKSUT_MAKSAJA) }}</mat-checkbox>
                        } @else {
                          <mat-checkbox [checked]="kayttaja.roolit[Roolit.MAKSUT_MAKSAJA]" disabled="true">{{ rooliMap.get(Roolit.MAKSUT_MAKSAJA) }}</mat-checkbox>
                        }
                      </div>
                    </td>
                    <td style="vertical-align: top; padding-right: 40px">
                      <mat-checkbox [formField]="lomake.RAPORTIT">{{ rooliMap.get(Roolit.RAPORTIT) }}</mat-checkbox>
                    </td>
                  </tr>
                </table>
              </td>
              <td style="width: 300px">
                <div style="padding-top: 10px; margin-bottom: 10px; margin-left: 0; margin-right: 0; font-size: 16px; line-height: 16px">Hallinto</div>
                <div style="padding-left: 20px; padding-top: 5px">
                  <mat-checkbox [formField]="lomake.HALLINTO_SOPIMUKSEN_HYVAKSYJA">{{ rooliMap.get(Roolit.HALLINTO_SOPIMUKSEN_HYVAKSYJA) }}</mat-checkbox>
                </div>
                <div style="padding-left: 20px; padding-top: 5px">
                  <mat-checkbox [formField]="lomake.HALLINTO_YHTEYSHENKILO">{{ rooliMap.get(Roolit.HALLINTO_YHTEYSHENKILO) }}</mat-checkbox>
                </div>
                <div style="padding-left: 20px; padding-top: 5px">
                  <mat-checkbox [formField]="lomake.HALLINTO_VIIA_VALTUUTUKSEN_ANTAJA">{{ rooliMap.get(Roolit.HALLINTO_VIIA_VALTUUTUKSEN_ANTAJA) }}</mat-checkbox>
                </div>
                <!-- <div style="padding-left: 20px; padding-top: 5px;">
                <mat-checkbox formControlName="HALLINTO_SUOMI_FI_VALTUUTUKSEN_ANTAJA">{{ rooliMap.get(Roolit.HALLINTO_SUOMI_FI_VALTUUTUKSEN_ANTAJA) }}</mat-checkbox>
              </div> -->
                <div style="padding-left: 20px; padding-top: 5px">
                  <mat-checkbox [formField]="lomake.HALLINTO_TUNTEMISTIETOJEN_ANTAJA">{{ rooliMap.get(Roolit.HALLINTO_TUNTEMISTIETOJEN_ANTAJA) }}</mat-checkbox>
                </div>
                <div style="padding-left: 20px; padding-top: 5px">
                  <mat-checkbox [formField]="lomake.TUNNISTETAAN">{{ rooliMap.get(Roolit.TUNNISTETAAN) }}</mat-checkbox>
                </div>
              </td>
            </tr>
          </table>

          @if (atLeastOneLemonaidRoleError()) {
            <div class="lemon-error" style="margin-top: 5px; margin-left: 20px">{{ atLeastOneLemonaidRoleError() }}</div>
          }

          <div style="padding-top: 30px; margin-bottom: 10px; margin-left: 0; margin-right: 0; border-bottom: 1px solid lightgray; font-size: 20px; line-height: 40px">Käyttäjän ominaisuudet</div>

          <div style="margin-left: 20px">
            <div class="gray-text">Älä laita päälle ominaisuuksia, joita käyttäjä ei ole pyytänyt.</div>
            <mat-checkbox [formField]="lomake.CAN_EDIT_PENALTY_INTEREST">Voi muokata laskujen viivästyskorkoa</mat-checkbox>
          </div>

          <div style="padding-top: 30px; margin-bottom: 10px; margin-left: 0; margin-right: 0; border-bottom: 1px solid lightgray; font-size: 20px; line-height: 40px">Tositteen lisäysprosessi kännykässä</div>

          <div style="margin-left: 20px">
            <table style="width: 100%; padding-top: 10px">
              <!-- <tr> -->
              <!-- <th colspan="2">Osa</th> -->
              <!-- <th>Järjestys</th> -->
              <!-- </tr> -->
              @for (osa of prosessinOsat; track osa.lisaysProsessinOsa.tunniste; let i = $index) {
                @if (lomake.prosessinOsat[i]; as osaRivi) {
                  <ng-container>
                    <tr style="vertical-align: top">
                      <td style="width: 40px">
                        <mat-checkbox [formField]="osaRivi.aktiivinen"></mat-checkbox>
                      </td>
                      <td>
                        <mat-form-field style="margin-top: -20px">
                          <input type="text" [formField]="osaRivi.otsikko" placeholder="Otsikko" matInput />
                        </mat-form-field>
                      </td>
                      <td>
                        <app-icon-button (click)="ylos(i)" actionId="Tositteen lisäysprosessi kännykässä: nuoli ylös" matIcon="arrow_drop_up"> </app-icon-button>
                        <app-icon-button (click)="alas(i)" actionId="Tositteen lisäysprosessi kännykässä: nuoli alas" matIcon="arrow_drop_down"> </app-icon-button>
                      </td>
                    </tr>
                    @if (naytaMaksutavat && osa.lisaysProsessinOsa.tunniste === 'editpaymentmethod') {
                      <tr>
                        <td colspan="3" style="padding-left: 70px; padding-top: 10px; padding-bottom: 15px">
                          <!-- <pre>{{kayttaja.maksutavat | json}}</pre> -->
                          Käytettävät maksutavat
                          @for (maksutapa of asiakkaanMaksutavat; track maksutapa.tunniste; let i = $index) {
                            @if (maksutapaRivit?.[i]; as maksutapaRivi) {
                              <div style="padding-top: 5px">
                                <mat-checkbox [formField]="maksutapaRivi.kaytossa">
                                  <div style="display: flex; align-items: center" [class.dark-gray-text]="!maksutapaRivi.kaytossa().value()">
                                    <img [src]="'data:image/png;base64,' + maksutapa.base64Kuva" style="margin: 0 10px; width: 40px; border-radius: 40px" [class.light-blue-background]="maksutapaRivi.kaytossa().value()" [class.light-gray-background]="!maksutapaRivi.kaytossa().value()" />
                                    <div style="margin: 0 10px; width: 300px">
                                      {{ maksutapa.nimi }}
                                      <!-- {{maksutapa.tunniste}} -->
                                    </div>
                                    <div style="display: flex; margin: 0 10px; width: 81px">
                                      @if (maksutapaRivi.kaytossa().value()) {
                                        <app-icon-button [disabled]="1 > i" (click)="maksutapaYlos($event, i)" actionId="Tositteen lisäysprosessi kännykässä: maksutapa nuoli ylös" matIcon="arrow_drop_up"> </app-icon-button>
                                        <app-icon-button [disabled]="i > aktivoitujenMaksutapojenLukumaara - 2" (click)="maksutapaAlas($event, i)" actionId="Tositteen lisäysprosessi kännykässä: maksutapa nuoli alas" matIcon="arrow_drop_down"> </app-icon-button>
                                      }
                                    </div>
                                  </div>
                                </mat-checkbox>
                              </div>
                            }
                          }
                        </td>
                      </tr>
                    }
                    @if (naytaAlvPortaat && osa.lisaysProsessinOsa.tunniste === 'editalv') {
                      <tr>
                        <td></td>
                        <td colspan="2">
                          <app-button (click)="lisaaAlvPorras()" actionId="Avattu muokkausnäkymä: Lisää alv porras rivi" styles="padding-left: 0;" matIcon="add"> Lisää porras </app-button>
                          <mat-radio-group [formField]="osaRivi.oletusporras">
                            <table id="alv-portaat-table">
                              <tr>
                                <th>Arvo</th>
                                <th style="width: 41px">Oletus</th>
                                <!-- <th style="width: 81px;">Järjestys</th> -->
                                <th style="width: 41px">Poista</th>
                              </tr>
                              @for (porras of kayttaja.alvVahennysoikeusPortaat; track porras; let i = $index) {
                                <tr>
                                  <td>
                                    <mat-form-field>
                                      <mat-label>Prosentti</mat-label>
                                      <input decimalNumberField matInput floatLabel="never" [numberOfDecimals]="0" [formField]="osaRivi.alvPortaat[i].arvo" />
                                    </mat-form-field>
                                  </td>
                                  <td style="text-align: center">
                                    <mat-radio-button [value]="i"></mat-radio-button>
                                  </td>
                                  <!-- <td style="text-align: center;">
                            <button mat-icon-button (click)="alvPorrasYlos(i)" type="button">
                              <mat-icon>arrow_drop_up</mat-icon>
                            </button>
                            <button mat-icon-button (click)="alvPorrasAlas(i)" type="button">
                              <mat-icon>arrow_drop_down</mat-icon>
                            </button>
                          </td> -->
                                  <td>
                                    <app-icon-button (click)="poistaAlvPorras(i)" actionId="Poista alv porras (käyttäjän tiedot)" matIcon="delete"> </app-icon-button>
                                  </td>
                                </tr>
                              }
                            </table>
                          </mat-radio-group>
                        </td>
                      </tr>
                    }
                  </ng-container>
                }
              }
            </table>
          </div>

          @if (commonError()) {
            <div class="error-text">
              {{ commonError() }}
            </div>
          }

          <div style="max-width: 900px">
            <div style="display: flex; justify-content: space-evenly; margin-top: 1em; margin-bottom: 1em">
              <app-secondary-button (click)="peruuta()" actionId="Peruuta">{{ 'yleiset.peruuta' | translate | async }}</app-secondary-button>
              <app-secondary-button (click)="save()" actionId="Tallenna asiakastiedot" [actionContext]="[$any(lomake().value())]">{{ 'yleiset.tallenna' | translate | async }}</app-secondary-button>
              <app-secondary-button (click)="saveTaikalinkki()" actionId="Tallenna asiakastiedot ja lähetä taikalinkki" [actionContext]="[$any(lomake().value())]"> Tallenna ja lähetä taikalinkki </app-secondary-button>
            </div>
            @if (lastMagicLinkSendObservable | async) {
              <div style="display: flex; justify-content: flex-end">
                <div class="dark-gray-text" style="font-size: 12px; margin-right: 15%">Linkki lähetetty {{ (lastMagicLinkSendObservable | async)?.pvm | ltimestamptimel: 'fi' }}</div>
              </div>
            }
          </div>
        </form>
      </div>
    </mat-tab>
    <mat-tab label="Luvat ja sopimukset" style="padding: 20px">
      <div style="padding: 20px">
        <div style="max-width: 900px">
          <div class="light-blue-text" style="font-size: 22px; margin-bottom: 10px; line-height: 30px; margin-top: 40px">Yleistiedot</div>
          <div class="cont">
            <div style="width: 300px">Asiakas luotu</div>
            <div>{{ (luvatJaSopimuksetObservable | async)?.asiakasLuotu }}</div>
          </div>
          <div class="cont">
            <div style="width: 300px">Käyttäjä luotu</div>
            <div>{{ (luvatJaSopimuksetObservable | async)?.kayttajaLuotu }}</div>
          </div>
        </div>
        <div class="cont">
          <div style="width: 300px">Viimeisin kirjautuminen</div>
          <div>{{ lastLoginObservable | async }}</div>
          <app-button (click)="naytaLoginHistoriaa()" actionId="Näytä login historia dialog" styles="cursor: pointer; color: #2dc8fa; line-height: 0;"> Historia </app-button>
        </div>
        <div style="max-width: 900px">
          <div class="light-blue-text" style="font-size: 22px; margin-bottom: 10px; line-height: 30px; margin-top: 40px">Tunnistaminen</div>
          <!-- <div class="cont">
      <div style="width: 300px;">Tupas</div>
      <div>N/A</div>
    </div> -->
          @if (luvatJaSopimuksetObservable | async; as luvatJaSopimukset) {
            @if (luvatJaSopimukset.tunnistamisStatus === 'ei-tunnistettu') {
              <div class="cont">Käyttäjää ei ole vielä tunnistettu</div>
            }
            @if (luvatJaSopimukset.tunnistamisStatus === 'tunnistettu-hetulla') {
              <div class="cont">
                <div style="width: 300px">Käyttäjän kirjoittama hetu</div>
                <div>{{ luvatJaSopimukset.hetu }}</div>
              </div>
            }
            @if (luvatJaSopimukset.tunnistamisStatus === 'tunnistettu-nets') {
              <div class="cont">
                <div style="width: 300px">Tunnistettu verkkopankkikirjautumisella</div>
                <div>{{ luvatJaSopimukset.hetu }}</div>
              </div>
            }
            @if (isAdmin()) {
              <app-button (click)="naytaVahvanTunnistautumisenHistoriaa()" actionId="Näytä vahvan tunnistautumisen historia" styles="cursor: pointer; color: #2dc8fa;"> Historia </app-button>
            }
          }
        </div>
        <div style="max-width: 900px">
          <div class="light-blue-text" style="font-size: 22px; margin-bottom: 10px; line-height: 30px; margin-top: 40px">Sopimukset</div>
          @for (hyvaksynta of sopimuksienHyvaksynnatObservable | async; track hyvaksynta) {
            <div class="cont">
              <div style="width: 300px">Versio {{ hyvaksynta.sopimusAvain }}</div>
              <div>{{ hyvaksynta.pvm | ltimestamptimel: 'fi' }}</div>
            </div>
          }
        </div>
        <!-- <div style="max-width: 900px;">
  <div class="light-blue-text" style="font-size: 22px; margin-bottom: 10px; line-height: 30px; margin-top: 40px;">Käyttöehdot</div>
  <div class="cont">
    <div style="width: 300px;">Versio xjdhyeogmj</div>
    <div>N/A</div>
  </div>
  <div class="cont">
    <div style="width: 300px;">Versio dkehtciwjs</div>
    <div>Odottaa asiakasta</div>
  </div>
</div> -->
        <!-- <div style="max-width: 900px;">
<div class="light-blue-text" style="font-size: 22px; margin-bottom: 10px; line-height: 30px; margin-top: 40px;">Suomi.fi -valtuutus</div>
<div class="cont">
  <div style="width: 300px;">Valtuutus annettu</div>
  <div>N/A (voimassa N/A asti)</div>
</div>
</div>
<div style="max-width: 900px;">
  <div class="light-blue-text" style="font-size: 22px; margin-bottom: 10px; line-height: 30px; margin-top: 40px;">Pankkiyhteysvaltuutus</div>
  <div class="cont">
    <div style="width: 300px;">Valtuutus 1</div>
    <div>N/A</div>
  </div>
  <div class="cont">
    <div style="width: 300px;">Valtuutus 2</div>
    <div>N/A</div>
  </div>
  <div class="cont">
    <div style="width: 300px;">Valtuutus 3</div>
    <div>N/A (voimassa N/A asti</div>
  </div>
</div> -->
      </div>
    </mat-tab>
    <mat-tab label="Laitteet" style="padding: 20px">
      <div style="padding: 20px">
        <p style="margin-bottom: 20px; max-width: 900px">Lemonaid-appin rekisteröimät laitteet ja niiden push-ilmoitusten tila. Laite päivittyy kirjautuessa, tokenin vaihtuessa ja korkeintaan kerran vuorokaudessa appin palatessa etualalle.</p>
        @if (laitteetObservable | async; as laitteet) {
          @if (!laitteet.length) {
            <div class="cont">Ei rekisteröityjä laitteita.</div>
          }
          @if (laitteet.length) {
            <div class="cont" style="font-weight: 600">
              <div style="width: 200px">Laite</div>
              <div style="width: 150px">Alusta</div>
              <div style="width: 110px">Sovellus</div>
              <div style="width: 260px">Push</div>
              <div style="width: 120px">Selvityspyynnöt</div>
              <div style="width: 150px">Rekisteröity</div>
              <div style="width: 150px">Päivitetty</div>
              <div style="flex: 1">Tila</div>
            </div>
            @for (laite of laitteet; track laite.fid) {
              <div class="cont" [style.color]="laite.poistettu ? 'gray' : null">
                <div style="width: 200px">{{ laite.laiteTeksti }}</div>
                <div style="width: 150px">{{ laite.alustaTeksti }}</div>
                <div style="width: 110px">{{ laite.sovellusTeksti }}</div>
                <div style="width: 260px">{{ laite.pushTeksti }}</div>
                <div style="width: 120px">{{ laite.ilmoituksetTeksti }}</div>
                <div style="width: 150px">{{ laite.rekisteroityTeksti }}</div>
                <div style="width: 150px">{{ laite.paivitettyTeksti }}</div>
                <div style="flex: 1">{{ laite.tilaTeksti }}</div>
              </div>
            }
          }
        }
      </div>
    </mat-tab>
    @if (moniyritystukiNakymaObservable | async; as moniyritys) {
      <mat-tab label="Moniyritystuki" style="padding: 20px">
        <div style="padding: 20px">
          <div style="max-width: 900px">
            <div class="light-blue-text" style="font-size: 22px; margin-bottom: 10px; line-height: 30px; margin-top: 40px">Moniyritystuki</div>
            <p style="margin-bottom: 20px">Käyttäjä voi vaihtaa Lemonaid-appissa yrityksestä toiseen ilman uutta kirjautumista. Osalliset päivittyvät automaattisesti henkilötunnuksen perusteella, kun käyttäjä tunnistautuu vahvasti tai hetu poistetaan. Ylläpidon Moniyritystuet-näkymässä (IT ja käyttötuki) voi tarkastella tukea ja ajaa uudelleenmuodostuksen.</p>
            @if (moniyritys.tuki; as tuki) {
              <div class="cont">
                <div style="width: 300px">Päivitetty</div>
                <div>{{ tuki.paivitetty | ltimestamptimel: 'fi' }}</div>
              </div>
              <h3 style="margin-top: 30px">Osalliset</h3>
              @for (osallinen of tuki.osalliset; track osallinen.kayttajaAvain) {
                <div style="display: flex; align-items: center; gap: 14px; padding: 8px 0; border-bottom: 1px solid rgba(0, 0, 0, 0.08)">
                  <div style="flex: 1">
                    <div style="font-weight: 600">{{ osallinen.asiakasNimi }}</div>
                    <div style="font-size: 12px; color: gray">{{ osallinen.ytunnus }}</div>
                  </div>
                  <div style="flex: 1">{{ osallinen.email }}</div>
                  <div style="width: 120px; font-size: 12px; color: gray">
                    @if (osallinen.kayttajaAvain === moniyritys.kayttajaAvain) {
                      Tämä käyttäjä
                    }
                  </div>
                </div>
              }
              @if (naytaMoniyritystukiLinkkiObservable | async) {
                <div style="margin-top: 20px">
                  <a [routerLink]="['/yllapito', 'moniyritystuet', tuki.avain]">Avaa moniyritystuki ylläpidossa</a>
                </div>
              }
            } @else {
              <div class="red-text">Moniyritystuen tiedot puuttuvat (tuki {{ moniyritys.tukiAvain }}). Ota yhteys käyttötukeen.</div>
            }
          </div>
        </div>
      </mat-tab>
    }
    @if (kirjanpitajaOnLuottoObservable | async) {
      <mat-tab label="Lähetetyt viestit" style="padding: 20px">
        <div style="padding: 20px">
          @if (lahetetytViestitObservable | async; as rivit) {
            @if (!rivit.length) {
              <div class="cont">Ei lähetettyjä viestejä.</div>
            }
            @if (rivit.length) {
              <div class="cont" style="font-weight: 600">
                <div style="width: 180px">Aika</div>
                <div style="width: 200px">Tyyppi</div>
                <div style="width: 100px">Kanava</div>
                <div style="width: 240px">Vastaanottaja</div>
                <div style="flex: 1">Sisältö</div>
                <div style="width: 40px"></div>
              </div>
              @for (rivi of rivit; track rivi.avain) {
                <div>
                  <div class="cont" style="align-items: center">
                    <div style="width: 180px">{{ rivi.pvm }}</div>
                    <div style="width: 200px">{{ rivi.tyyppiTeksti }}</div>
                    <div style="width: 100px">{{ rivi.kanavaTeksti }}</div>
                    <div style="width: 240px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{ rivi.vastaanottaja }}</div>
                    <div style="flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #666">{{ rivi.esikatselu }}</div>
                    <app-icon-button (click)="rivi.naytaSisalto = !rivi.naytaSisalto" [actionId]="rivi.naytaSisalto ? 'Piilota lähetetyn viestin sisältö' : 'Näytä lähetetyn viestin sisältö'" styles="width: 40px; height: 40px;">
                      <mat-icon>{{ rivi.naytaSisalto ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </app-icon-button>
                  </div>
                  @if (rivi.naytaSisalto) {
                    <div style="background: #f5f5f5; border-radius: 4px; padding: 12px 16px; margin: 4px 0 8px">
                      <div style="white-space: pre-wrap; font-family: inherit">{{ rivi.sisaltoText }}</div>
                    </div>
                  }
                </div>
              }
              @if (naytaLisaaLahetettyjaViestejaObservable | async) {
                <div style="margin-top: 16px">
                  <app-button (click)="naytaLisaaLahetettyjaViesteja()" actionId="Lataa lisää lähetettyjä viestejä">Näytä lisää</app-button>
                </div>
              }
            }
          }
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</div>

<!-- <pre>{{ kayttaja | json }}</pre> -->
